import React, { useState } from 'react';

// Password field with a show/hide eye toggle, matching the eye button used on
// the Login page. Used in the "Profili Düzenle → Şifreyi Değiştir" flow.
const PasswordInput: React.FC<{
  value: string;
  onChange: (v: string) => void;
  borderColor?: string;
  placeholder?: string;
  /** Standart form boyutu (Profili Düzenle) — login'deki büyük varyantın yerine. */
  compact?: boolean;
}> = ({ value, onChange, borderColor = '#3973bf', placeholder, compact = false }) => {
  const [show, setShow] = useState(false);
  return (
    <div
      className={compact
        ? 'w-full flex items-center bg-white rounded-[10px] px-3 py-2 gap-2'
        : 'w-full flex items-center bg-[#fafafa] rounded-[16px] px-5 py-4 gap-3'}
      style={{ border: compact ? '1.5px solid #d4d4d4' : `2.6px solid ${borderColor}`, fontFamily: 'Inter' }}
    >
      <input
        type={show ? 'text' : 'password'}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        autoCapitalize="off"
        autoCorrect="off"
        spellCheck={false}
        className={compact
          ? 'flex-1 min-w-0 bg-transparent outline-none text-[14px] text-[#2b2b2b]'
          : 'flex-1 bg-transparent outline-none text-[16px] text-[#2b2b2b]'}
        style={{ fontFamily: 'Inter' }}
      />
      <button
        type="button"
        onClick={() => setShow((v) => !v)}
        className="text-[#3973bf] hover:text-[#2b58a0] focus:outline-none flex-shrink-0"
        aria-label={show ? 'Şifreyi gizle' : 'Şifreyi göster'}
      >
        {show ? (
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M17.94 17.94A10.94 10.94 0 0112 20c-7 0-11-8-11-8a21.84 21.84 0 015.17-6.17M9.9 4.24A10.94 10.94 0 0112 4c7 0 11 8 11 8a21.77 21.77 0 01-3.17 4.35M1 1l22 22" />
            <path d="M9.88 9.88a3 3 0 104.24 4.24" />
          </svg>
        ) : (
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
            <circle cx="12" cy="12" r="3" />
          </svg>
        )}
      </button>
    </div>
  );
};

export default PasswordInput;
